// extracted by mini-css-extract-plugin
export var bigText = "MainPoints-module--big-text--9ed19";
export var item = "MainPoints-module--item--edf87";
export var itemTitle = "MainPoints-module--item-title--e353a";
export var layout = "MainPoints-module--layout--c439f";
export var richText = "MainPoints-module--rich-text--f6661";
export var text = "MainPoints-module--text--b361c";
export var title = "MainPoints-module--title--e080e";
export var wrapper = "MainPoints-module--wrapper--a0d48";